import React from 'react'
import {expandReference } from '../lib/utils';
import ScadenzaCollaudoQuinquennaleCollaudoAnnuale from './deadlines/Scadenza-CollaudoQuinquennale-CollaudoAnnuale'
import ScadenzaCollaudoRevisione from './deadlines/Scadenza-Collaudo-Revisione';
import Scadenza from './deadlines/Scadenza';
import ScadenzaTagliando from './deadlines/Scadenza-Tagliando';
import ScadenzaCollaudo from './deadlines/Scadenza-Collaudo';
import ScadenzaManuale from './deadlines/ScadenzaManuale';
import {VisDiv} from '../components';
import {DataScadenzaCollaudoQuinquennaleCollaudoAnnuale, DataScadenzaManuale, DataScadenzaCollaudoRevisione, DataScadenza, DataScadenzaTagliando, DataScadenzaCollaudo} from '../lib/ScadenzeData'


/**
 * Function to render deadlines for a device based on the device template and custom year. 
 * #deadlines
 * @param {object} device - The device object
 * @param {object} template - The device template object
 * @param {number} customYear - The custom year to use for the deadlines
 * 
 * @returns {object} An object containing the JSX component for the deadlines, the maintenance tasks list and the deadline type
 */
const deadlines = (device, template, customYear) => {
  
    const deviceTemplate = expandReference(device?.templateDevice,template?.devices)
    
   
    const deadlineType = template?.deadlineType?.label


    const testFunction = () => {

        //console.log(deadlineType)

    }
    //console.log("wiuefjcwe78cew", DataScadenza(device, deviceTemplate, template))
    //CASI SCADENZE

    switch (deadlineType) {
        case "Scadenza-CollaudoQuinquennale-CollaudoAnnuale":
            return ( 
                {
                deadlines: <ScadenzaCollaudoQuinquennaleCollaudoAnnuale
                   device={device}
                   deviceTemplate={deviceTemplate}
                   registerTemplate={template}
                    />,
                data: DataScadenzaCollaudoQuinquennaleCollaudoAnnuale(device, deviceTemplate, template, customYear).maintenanceTasksList,
                deadlineType: "Scadenza-CollaudoQuinquennale-CollaudoAnnuale",
                checkData: DataScadenzaCollaudoQuinquennaleCollaudoAnnuale(device, deviceTemplate, template, customYear)
            }  )
        case "Scadenza":
            return ( 
                {
                deadlines: <Scadenza
                    device={device}
                    deviceTemplate={deviceTemplate}
                    registerTemplate={template}
                    />,
                data: DataScadenza(device, deviceTemplate, template, customYear)?.maintenanceTasksList,
                deadlineType: "Scadenza",
                checkData: DataScadenza(device, deviceTemplate, template, customYear)
            }  )
        case "Scadenza-Collaudo-Revisione":
            return ( 
                {
                deadlines: <ScadenzaCollaudoRevisione
                   device={device}
                   deviceTemplate={deviceTemplate}
                   registerTemplate={template}
                    />,
                data: DataScadenzaCollaudoRevisione(device, deviceTemplate, template, customYear)?.maintenanceTasksList,
                deadlineType: "Scadenza-Collaudo-Revisione",
                checkData: DataScadenzaCollaudoRevisione(device, deviceTemplate, template, customYear)
            }  )  
        case "Scadenza-Tagliando":
            return ( 
                {
                deadlines: <ScadenzaTagliando
                    device={device}
                    deviceTemplate={deviceTemplate}
                    registerTemplate={template}
                    />,
                data: DataScadenzaTagliando(device, deviceTemplate, template, customYear)?.maintenanceTasksList,
                deadlineType: "Scadenza-Tagliando",
                checkData: DataScadenzaTagliando(device, deviceTemplate, template, customYear)
            }  )  
        case "Scadenza-Collaudo":
            return ( 
                {
                deadlines: <ScadenzaCollaudo
                    device={device}
                    deviceTemplate={deviceTemplate}
                    registerTemplate={template}
                    />,
                data: DataScadenzaCollaudo(device, deviceTemplate, template, customYear)?.maintenanceTasksList,
                deadlineType: "Scadenza-Collaudo",
                checkData: DataScadenzaCollaudo(device, deviceTemplate, template, customYear)
            }  )
            case "ScadenzaManuale":
                return ( 
                    {
                    deadlines: <ScadenzaManuale
                        device={device}
                        deviceTemplate={deviceTemplate}
                        registerTemplate={template}
                        />,
                    data: DataScadenzaManuale(device, deviceTemplate, template, customYear)?.maintenanceTasksList,
                    deadlineType: "ScadenzaManuale",
                    checkData: DataScadenzaManuale(device, deviceTemplate, template, customYear)
                }  )        
        default:
            return (
                {
                    deadlines: <div></div>,
                    data: [],
                    deadlineType: "default"
                }
            )
    }


}

export default deadlines
